import React from 'react';
import { DesBanner, PjmBanner, MultiBanner } from './banners';

interface UpmarketBannersVariantTypes {
  upmarketBannerVariants: {
    withPjmBanner: boolean;
    withDesBanner: boolean;
    withMultiVariantBanner: boolean;
  };
}

export const UpmarketBanners: React.FC<UpmarketBannersVariantTypes> = ({ upmarketBannerVariants }) => {
  const { withPjmBanner, withDesBanner, withMultiVariantBanner } = upmarketBannerVariants;

  if (!withPjmBanner && !withDesBanner && !withMultiVariantBanner) {
    return null;
  }

  return (
    <>
      {withPjmBanner && <PjmBanner />}
      {withDesBanner && <DesBanner />}
      {withMultiVariantBanner && <MultiBanner />}
    </>
  );
};

export default UpmarketBanners;
